const consoleStyles = {
  default: 'color: orange; font-weight: bold;',
  success: 'color: green; font-weight: bold;',
  error: 'color: red; font-weight: bold;',
};

export default consoleStyles;
